import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '800px', margin: '40px auto', padding: '40px' }}>
        <h1 style={{ color: 'var(--primary-color)', marginBottom: '20px' }}>Terms and Conditions</h1>
        
        <div style={{ color: 'var(--text-secondary)', marginBottom: '30px' }}>
          <p><strong>Effective Date:</strong> June 9, 2025</p>
          <p><strong>Last Updated:</strong> June 9, 2025</p>
        </div>

        <p style={{ marginBottom: '20px' }}>
          Welcome to PrepNest ("Website", "we", "our", or "us"). These Terms and Conditions ("Terms")
          govern your use of our website and services that enable students in India to take paid online exams.
        </p>
        
        <p style={{ marginBottom: '30px' }}>
          By accessing or using our Website, creating an account, or making payments through Razorpay, 
          you agree to be bound by these Terms. If you do not agree, please do not use the Website.
        </p>

        <div className="terms-section">
          <h2>1. Eligibility</h2>
          <p>The Website is intended for students, generally aged between 6 to 18 years.</p>
          <p>If you are under 18, your parent or legal guardian must read and agree to these Terms on your behalf.</p>
        </div>

        <div className="terms-section">
          <h2>2. Account Creation</h2>
          <p>To use our services, you must:</p>
          <ul>
            <li>Provide a valid email address (mandatory).</li>
            <li>Provide a phone number (optional but recommended for support and verification).</li>
            <li>Create a password and maintain confidentiality of your login credentials.</li>
          </ul>
          <p>You are responsible for all activities under your account.</p>
        </div>

        <div className="terms-section">
          <h2>3. Exam Registration and Payments</h2>
          <ul>
            <li>Each exam requires a separate registration and payment.</li>
            <li>Payment must be made through our integrated payment gateway provided by Razorpay.</li>
            <li>All prices will be displayed clearly before checkout and are inclusive of applicable taxes.</li>
            <li>We do not store your card or bank details. Razorpay handles all payment processing securely.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>4. Refund and Cancellation Policy</h2>
          <p>Once payment is made for an exam, it cannot be refunded, except in cases where:</p>
          <ul>
            <li>The exam was not accessible due to a technical failure on our end.</li>
            <li>Duplicate payments were made for the same exam.</li>
          </ul>
          <p>For refund requests, contact us at prepnest.2025@gmail.com within 7 working days of the payment.</p>
        </div>

        <div className="terms-section">
          <h2>5. Use of Content</h2>
          <ul>
            <li>All content, including questions, solutions, and learning material, is owned by or licensed to www.prepnest.org.</li>
            <li>You may use the content only for personal educational purposes.</li>
            <li>Reproduction, resale, distribution, or public display of our content is strictly prohibited without prior written permission.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>6. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Share your account credentials with others.</li>
            <li>Use the Website for cheating or dishonest behavior in exams.</li>
            <li>Attempt to breach or bypass security features of the Website.</li>
          </ul>
          <p>We reserve the right to suspend or terminate your account for any violations.</p>
        </div>

        <div className="terms-section">
          <h2>7. Privacy</h2>
          <p>We are committed to protecting your personal information. Your email and phone number are stored securely and used only for:</p>
          <ul>
            <li>Account communication and support.</li>
            <li>Exam-related notifications.</li>
          </ul>
          <p>We do not sell or share your information with third parties for marketing purposes. For details, please read our Privacy Policy.</p>
        </div>

        <div className="terms-section">
          <h2>8. Third-Party Services</h2>
          <ul>
            <li>Payments are processed by Razorpay, a third-party service provider.</li>
            <li>By making a payment, you also agree to Razorpay's Terms of Use and Privacy Policy.</li>
            <li>We are not liable for issues that arise directly from Razorpay's platform.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>9. Limitation of Liability</h2>
          <p>We are not responsible for:</p>
          <ul>
            <li>Any temporary unavailability of the Website due to technical issues.</li>
            <li>User errors such as wrong exam selection or incorrect information during sign-up.</li>
            <li>Internet or device failure on your part while taking an exam.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>10. Modifications</h2>
          <p>
            We may update these Terms at any time. Changes will be posted on this page, and your continued 
            use of the Website after changes means you accept the new Terms.
          </p>
        </div>

        <div className="terms-section">
          <h2>11. Contact Information</h2>
          <p>For any questions or support, please contact us at:</p>
          <p>📧 prepnest.2025@gmail.com</p>
          <p>📞 +91-9014716089</p>
        </div>

        <p style={{ marginTop: '40px', fontStyle: 'italic' }}>
           By using our Website, you acknowledge that you have read and understood these terms.
        </p>
      </div>
    </div>
  );
};

export default Terms; 